import React from 'react'
import './Services.css'
import HeartEmoji from '../../img/heartemoji.png'
import Glasses from '../../img/glasses.png'
import Humble from '../../img/humble.png'
import Card from '../Card/Card.jsx'
import Resume from './AkashYadav.pdf'
import { themeContext } from '../../Context'
import { useContext } from 'react'
import { motion } from 'framer-motion'
const Services = () => {
    const transition = {duration:1, type :'spring'}
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className="services" id="Services">
        {/* left side */ }
        <div className="awesome">
            <span style={{color:darkMode? 'white' : ''}}>My Awesome</span>
            <span>Services</span>
            <spane>As a web developer, and machine learning expert  
            <br />
            I provide a range of services to clients looking to build
            <br />
            robust and efficient software solutions.
            <br />
            With expertise in front-end and back-end web development,
            <br />
            I am able to offer clients a comprehensive suite of services
            <br />
            that can be tailored to meet their specific needs.
            </spane>
            <a href={Resume} download>
                <button className="button s-button">
                    Dowload CV
                </button>
            </a>
            
            <div className="blur s-blur1" style={{background:"#ABF1FF94"}}></div>
        </div>
        {/* right side*/}
        <div className="cards" >
            <motion.div 
            initial={{left:'25%'}}
            whileInView={{left:'15rem'}}
            transition={transition}
            style={{left:'14rem'}}>
                <Card 
                emoji = {HeartEmoji}
                heading= {'Design'}
                detail = {"Figma, Photoshop, Adobe"}
                />
            </motion.div>
            <motion.div 
            initial={{left:'25%'}}
            whileInView={{right:'15rem'}}
            transition={transition}
            style={{top:'12rem',left:'-4rem'}}>
                <Card 
                emoji = {Glasses}
                heading= {'Developer'}
                detail = {"Html, CSS, Javascript, React"}
                />
            </motion.div>
            <motion.div 
            nitial={{left:'25%'}}
            whileInView={{left:'15rem'}}
            transition={transition}
            style={{top:'19rem',left:'12rem'}}>
                <Card 
                emoji = {Humble}
                heading= {'ML/AI'}
                detail = {"Machine Learning, Artificial Intelligence"}
                />
            </motion.div>
            <div className="blur s-blur2" style={{background:"var(--purple"}}>

            </div>
        </div>
    </div>
  )
}

export default Services